import React from 'react';
import Proptypes from 'prop-types';
import './Emoji.css';

export default function Emoji({ emoji, isPressed}) {
  return (
    <div 
      className={`emoji ${isPressed ? 'emoji-container pressed' : 'emoji-container'}`} 
      id={emoji}>
        {emoji}
    </div>
  )
}

Emoji.propTypes = {
    emoji: Proptypes.string.isRequired,
    isPressed: Proptypes.bool,
    size: Proptypes.string,
};
